var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.loading)?_c('VFilters',{attrs:{"allowed-filters":_vm.allowedFilters,"filter-groups":_vm.filterGroups,"default-filters":_vm.$route.query.filter || {}}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }